import { render, staticRenderFns } from "./svg-other.vue?vue&type=template&id=30346936&scoped=true"
import script from "./svg-other.vue?vue&type=script&setup=true&lang=ts"
export * from "./svg-other.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./svg-other.vue?vue&type=style&index=0&id=30346936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30346936",
  null
  
)

export default component.exports